$(document).ready(function() {
  const $tabs = $('.pdp8_guidelines_tab ul li a');
  const $contents = $('.pdp8_guidelines_listheading');

  // Initial setup: activate first tab and show first content
  $tabs.removeClass('active');
  $tabs.first().addClass('active');
  $contents.hide();
  $('.pdp8_guidelines_listheading1').show();

  // On tab click
  $tabs.on('click', function(e) {
    e.preventDefault();

    const index = $(this).parent().index() + 1; // get 1-based index (1..4)

    // Update active tab
    $tabs.removeClass('active');
    $(this).addClass('active');

    // Show corresponding content
    $contents.hide();
    $(`.pdp8_guidelines_listheading${index}`).show();
  });
});


